export type WorldsSwitcherProduct = "flow" | "vibe" | "worlds";

export interface WorldsAppDefinition {
  id: WorldsSwitcherProduct;
  name: string;
  description: string;
  canonicalOrigin: string;
  liveDestination: string;
  monogram: string;
}

export interface WorldsAppLocation {
  hostname: string;
  origin: string;
  pathname: string;
  search: string;
  hash: string;
}

export const WORLDS_SWITCHER_APPS: readonly WorldsAppDefinition[] = [
  {
    id: "flow",
    name: "Flow",
    description: "Generate, edit, and deliver video",
    canonicalOrigin: "https://flow.centience.io",
    liveDestination: "https://flow.centience.io/",
    monogram: "FL",
  },
  {
    id: "vibe",
    name: "Vibe",
    description: "Generate, arrange, and mix music",
    canonicalOrigin: "https://vibe.centience.io",
    liveDestination: "https://centience.io/?app=vibe",
    monogram: "VI",
  },
  {
    id: "worlds",
    name: "Worlds",
    description: "Build and explore interactive worlds",
    canonicalOrigin: "https://worlds.centience.io",
    liveDestination: "https://centience-worlds.pages.dev/",
    monogram: "WO",
  },
];

const productionHosts = new Set([
  "centience.io",
  ...WORLDS_SWITCHER_APPS.flatMap((app) => [
    new URL(app.canonicalOrigin).hostname,
    new URL(app.liveDestination).hostname,
  ]),
]);

export function worldsAppDestination(
  product: WorldsSwitcherProduct,
  location: WorldsAppLocation,
): string {
  const app = WORLDS_SWITCHER_APPS.find((candidate) => candidate.id === product);
  if (!app) return location.origin;

  if (productionHosts.has(location.hostname.toLowerCase()) || product !== "worlds") {
    return app.liveDestination;
  }

  const destination = new URL(`${location.pathname}${location.search}${location.hash}`, location.origin);
  destination.searchParams.delete("app");
  return destination.toString();
}
